import { useJustSubmittedIndividualConsent } from '@/components/idv/useJustSubmittedIndividualConsent';
import {
    IdvPosition,
    useBaseIdvPosition,
} from '@common/react/idv/useBaseIdvPosition';

export const useIdvPosition = (): IdvPosition => {
    const [justSubmittedIndividualConsent] =
        useJustSubmittedIndividualConsent();
    return useBaseIdvPosition({
        justSubmittedIndividualConsent: !!justSubmittedIndividualConsent,
    });
};
